export const REQUEST_TRIPS = 'REQUEST_TRIPS';
export const RECEIVE_TRIPS = 'RECEIVE_TRIPS';
export const REQUEST_RELATED_TRIPS = 'REQUEST_RELATED_TRIPS';
export const RECEIVE_RELATED_TRIPS = 'RECEIVE_RELATED_TRIPS';
export const REQUEST_ADDITIONAL_TRIPS = 'REQUEST_ADDITIONAL_TRIPS';
export const RECEIVE_ADDITIONAL_TRIPS = 'RECEIVE_ADDITIONAL_TRIPS';
export const RECEIVE_TRIPS_FAILURE = 'RECEIVE_TRIPS_FAILURE';
export const CLEAR_TRIPS_ERROR = 'CLEAR_TRIPS_ERROR';
export const SET_TRIPS_OFFSET = 'SET_TRIPS_OFFSET';
export const SET_TRIP_VEHICLE_FILTER = 'SET_TRIP_VEHICLE_FILTER';
export const SET_TRIP_SORT_FILTER = 'SET_TRIP_SORT_FILTER';
export const TOGGLE_SHOW_ALL_TRIPS = 'TOGGLE_SHOW_ALL_TRIPS';
export const RECEIVE_FEATURED_PROMOS = 'RECEIVE_FEATURED_PROMOS';
export const RECEIVE_HOMEPAGE_BANNERS = 'RECEIVE_HOMEPAGE_BANNERS';

export const REQUEST_SLIDERS = 'REQUEST_SLIDERS';
export const RECEIVE_SLIDERS = 'RECEIVE_SLIDERS';

export const REQUEST_TRIP_DETAILS = 'REQUEST_TRIP_DETAILS';
export const RECEIVE_TRIP_DETAILS = 'RECEIVE_TRIP_DETAILS';
export const RECEIVE_TRIP_DETAILS_FAILURE = 'RECEIVE_TRIP_DETAILS_FAILURE';
export const CLEAR_TRIP_DETAILS_ERROR = 'CLEAR_TRIP_DETAILS_ERROR';

export const SET_ACTIVE_TRIP_POPUP = 'SET_ACTIVE_TRIP_POPUP';
export const TOGGLE_ACTIVE_TRIP_POPUP = 'TOGGLE_ACTIVE_TRIP_POPUP';

export const SET_BOOKING_AVAIL_DATES = 'SET_BOOKING_AVAIL_DATES';
export const SET_BOOKING_UNAVAIL_DATES = 'SET_BOOKING_UNAVAIL_DATES';
export const SET_BOOKING_DATE = 'SET_BOOKING_DATE';
export const SET_BOOKING_PAX = 'SET_BOOKING_PAX';
export const SET_BOOKING_VEHICLE = 'SET_BOOKING_VEHICLE';
export const SET_BOOKING_MEETING_POINT = 'SET_BOOKING_MEETING_POINT';
export const SET_BOOKING_PRICE = 'SET_BOOKING_PRICE';
export const SET_BOOKING_FORM_DATA = 'SET_BOOKING_FORM_DATA';
export const SET_BOOKING_PRIMARY_DRIVER = 'SET_BOOKING_PRIMARY_DRIVER';
export const SET_BOOKING_STEP = 'SET_BOOKING_STEP';
export const SET_DATE_WAS_RESET = 'SET_DATE_WAS_RESET';
export const CLEAR_BOOKING_FORM_DATA = 'CLEAR_BOOKING_FORM_DATA';
export const TOGGLE_PROCEED_TO_PAYMENT = 'TOGGLE_PROCEED_TO_PAYMENT';
export const TOGGLE_AGREE_CANCELLATION_POLICY =
  'TOGGLE_AGREE_CANCELLATION_POLICY';

export const REQUEST_BOOKING_INFO = 'REQUEST_BOOKING_INFO';
export const RECEIVE_BOOKING_INFO = 'RECEIVE_BOOKING_INFO';
export const REQUEST_PRICING_INFO = 'REQUEST_PRICING_INFO';
export const RECEIVE_PRICING_INFO = 'RECEIVE_PRICING_INFO';
export const REQUEST_BOOKING_STATUS = 'REQUEST_BOOKING_STATUS';
export const RECEIVE_BOOKING_STATUS = 'RECEIVE_BOOKING_STATUS';
export const REQUEST_BOOKING_COMPANIONS = 'REQUEST_BOOKING_COMPANIONS';
export const RECEIVE_BOOKING_COMPANIONS = 'RECEIVE_BOOKING_COMPANIONS';

export const SEND_BOOKING_FORM = 'SEND_BOOKING_FORM';
export const SEND_BOOKING_FORM_WITH_AUTH = 'SEND_BOOKING_FORM_WITH_AUTH';
export const RECEIVE_BOOKING_FORM_RESPONSE = 'RECEIVE_BOOKING_FORM_RESPONSE';
export const CLEAR_PAYMENT_DATA = 'CLEAR_PAYMENT_DATA';
export const SEND_COMPANION_FORM = 'SEND_COMPANION_FORM';
export const RECEIVE_COMPANION_FORM_RESPONSE =
  'RECEIVE_COMPANION_FORM_RESPONSE';

export const REQUEST_FAQS = 'REQUEST_FAQS';
export const RECEIVE_FAQS = 'RECEIVE_FAQS';

export const REQUEST_STORIES = 'REQUEST_STORIES';
export const RECEIVE_STORIES = 'RECEIVE_STORIES';
export const SET_ACTIVE_STORY = 'SET_ACTIVE_STORY';
export const RECEIVE_STORIES_ERROR = 'RECEIVE_STORIES_ERROR';

export const REQUEST_PAST_EXPERIENCES = 'REQUEST_PAST_EXPERIENCES';
export const RECEIVE_PAST_EXPERIENCES = 'RECEIVE_PAST_EXPERIENCES';
export const SET_ACTIVE_PAST_EXPERIENCES = 'SET_ACTIVE_PAST_EXPERIENCES';
export const RECEIVE_PAST_EXPERIENCES_ERROR = 'RECEIVE_PAST_EXPERIENCES_ERROR';

export const TOGGLE_LIGHTBOX = 'TOGGLE_LIGHTBOX';
export const SET_LIGHTBOX_IMAGE = 'SET_LIGHTBOX_IMAGE';
export const CLEAR_LIGHTBOX_GALLERIES = 'CLEAR_LIGHTBOX_GALLERIES';
export const POPULATE_LIGHTBOX_GALLERY = 'POPULATE_LIGHTBOX_GALLERY';
export const SAVE_LIGHTBOX_GALLERY = 'SAVE_LIGHTBOX_GALLERY';
export const SET_LIGHTBOX_VIDEO = 'SET_LIGHTBOX_VIDEO';

export const RECEIVE_ERROR_RESPONSE = 'RECEIVE_ERROR_RESPONSE';
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR';

// Authentication
export const SIGN_UP = 'SIGN_UP';
export const COMPLETE_SIGN_UP = 'COMPLETE_SIGN_UP';
export const SIGN_IN = 'SIGN_IN';
export const COMPLETE_SIGN_IN = 'COMPLETE_SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const COMPLETE_SIGN_OUT = 'COMPLETE_SIGN_OUT';
export const RECEIVE_AUTH_ERROR = 'RECEIVE_AUTH_ERROR';
export const CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP';
export const COMPLETE_CONFIRM_SIGN_UP = 'COMPLETE_CONFIRM_SIGN_UP';
export const RESEND_CODE = 'RESEND_CODE';
export const COMPLETE_RESEND_CODE = 'COMPLETE_RESEND_CODE';
export const SET_AUTH_EMAIL = 'SET_AUTH_EMAIL';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const COMPLETE_REQUEST_PASSWORD_RESET =
  'COMPLETE_REQUEST_PASSWORD_RESET';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const COMPLETE_CHANGE_PASSWORD = 'COMPLETE_CHANGE_PASSWORD';
export const SUBMIT_FORGOT_PASSWORD = 'SUBMIT_FORGOT_PASSWORD';
export const COMPLETE_SUBMIT_FORGOT_PASSWORD =
  'COMPLETE_SUBMIT_FORGOT_PASSWORD';
export const CHECK_CURRENT_USER = 'CHECK_CURRENT_USER';
export const COMPLETE_CHECK_CURRENT_USER = 'COMPLETE_CHECK_CURRENT_USER';
export const REDIRECT = 'REDIRECT';
export const RECEIVE_USERNAME = 'RECEIVE_USERNAME';

// My bookings
export const REQUEST_MY_BOOKINGS = 'REQUEST_MY_BOOKINGS';
export const RECEIVE_MY_BOOKINGS = 'RECEIVE_MY_BOOKINGS';
export const REQUEST_MY_BOOKING_DETAILS = 'REQUEST_MY_BOOKING_DETAILS';
export const RECEIVE_MY_BOOKING_DETAILS = 'RECEIVE_MY_BOOKING_DETAILS';
export const REQUEST_MY_BOOKING_COMPANIONS = 'REQUEST_MY_BOOKING_COMPANIONS';
export const RECEIVE_MY_BOOKING_COMPANIONS = 'RECEIVE_MY_BOOKING_COMPANIONS';
export const UPDATE_MY_BOOKING_COMPANIONS = 'UPDATE_MY_BOOKING_COMPANIONS';
export const COMPLETE_UPDATE_MY_BOOKING_COMPANIONS =
  'COMPLETE_UPDATE_MY_BOOKING_COMPANIONS';

// Reviews
export const RESET_REVIEW_STATE = 'RESET_REVIEW_STATE';
export const REQUEST_CREATE_REVIEW = 'REQUEST_CREATE_REVIEW';
export const RECEIVE_CREATE_REVIEW = 'RECEIVE_CREATE_REVIEW';
export const REQUEST_REVIEW_LIST = 'REQUEST_REVIEW_LIST';
export const RECEIVE_REVIEW_LIST = 'RECEIVE_REVIEW_LIST';
export const SUBMIT_REVIEW = 'SUBMIT_REVIEW';
export const RECEIVE_SUBMIT_REVIEW_RESPONSE = 'RECEIVE_SUBMIT_REVIEW_RESPONSE';
export const RECEIVE_REVIEWS_ERROR = 'RECEIVE_REVIEWS_ERROR';
export const REQUEST_MORE_REVIEWS = 'REQUEST_MORE_REVIEWS';
export const RECEIVE_MORE_REVIEWS = 'RECEIVE_MORE_REVIEWS';
export const SET_REVIEWS_TO_SHOW = 'SET_REVIEWS_TO_SHOW';

// Save for later
export const SEND_SAVE_FOR_LATER = 'SEND_SAVE_FOR_LATER';
export const RECEIVE_SAVE_FOR_LATER_RESPONSE =
  'RECEIVE_SAVE_FOR_LATER_RESPONSE';
export const REQUEST_SAVED_INFO = 'REQUEST_SAVED_INFO';
export const RECEIVE_SAVED_INFO = 'RECEIVE_SAVED_INFO';
export const REQUEST_DELETE_SAVED_INFO = 'REQUEST_DELETE_SAVED_INFO';
export const RECEIVE_DELETE_SAVED_INFO = 'RECEIVE_DELETE_SAVED_INFO';

// CONTEST
export const RECEIVE_CONTEST_ITEMS = 'RECEIVE_CONTEST_ITEMS';
export const REQUEST_CONTEST_ITEMS = 'REQUEST_CONTEST_ITEMS';
export const CONTEST_HAS_SUBMITTED = 'CONTEST_HAS_SUBMITTED';
export const CLEAR_CONTEST_SUBMITTED_ERROR = 'CLEAR_CONTEST_SUBMITTED_ERROR';
export const RECEIVE_CONTEST_SUBMITTED_ERROR =
  'RECEIVE_CONTEST_SUBMITTED_ERROR';
export const TOGGLE_ACTIVE_CONTEST_POPUP = 'TOGGLE_ACTIVE_CONTEST_POPUP';
export const TOGGLE_ACTIVE_AUTH_POPUP = 'TOGGLE_ACTIVE_AUTH_POPUP';
export const SET_ACTIVE_CONTEST_POPUP = 'SET_ACTIVE_CONTEST_POPUP';
export const SET_CONTEST_MODE = 'SET_CONTEST_MODE';
export const SET_SIGNUP_FLOW = 'SET_SIGNUP_FLOW';
export const SET_CONTEST_STEP = 'SET_CONTEST_STEP';
// export const RECEIVE_CONTEST_AUTH_ERROR = 'RECEIVE_CONTEST_AUTH_ERROR';
// export const CLEAR_CONTEST_AUTH_ERROR = 'CLEAR_CONTEST_AUTH_ERROR';

// BYOR
export const TOGGLE_SELECT_BYOR = 'TOGGLE_SELECT_BYOR';
export const RESET_SELECT_BYOR = 'RESET_SELECT_BYOR';
export const RECEIVE_BYOR_IS_MEMBER_RESPONSE =
  'RECEIVE_BYOR_IS_MEMBER_RESPONSE';
export const REQUEST_BYOR_IS_MEMBER = 'REQUEST_BYOR_IS_MEMBER';
export const RESET_BYOR = 'RESET_BYOR';
export const SET_BYOR_VEHICLE_NO = 'SET_BYOR_VEHICLE_NO';
export const SET_VEHICLE_NO_AND_MODEL = 'SET_VEHICLE_NO_AND_MODEL';
